export const LorenHttpResponseErrorStatuses = {
  INVALID_PASSWORD: "INVALID_PASSWORD",
  PASSWORD_TOO_SHORT: "PASSWORD_TOO_SHORT",
  EMAIL_INVALID: "EMAIL_INVALID",
  USERNAME_TOO_SHORT: "USERNAME_TOO_SHORT",
  USERNAME_ALREADY_REGISTERED: "USERNAME_ALREADY_REGISTERED",
  EMAIL_ALREADY_REGISTERED: "EMAIL_ALREADY_REGISTERED",
  IMAGE_TOO_LARGE: "IMAGE_TOO_LARGE",
  SAME_PASSWORD: "SAME_PASSWORD",
  OPERATION_SYSTEM_ERROR: "OPERATION_SYSTEM_ERROR",
};
